export enum ContributionPeriodicity {
	MONTHLY = 'MONTHLY',
	BI_MONTHLY = 'BI_MONTHLY',
	QUARTERLY = 'QUARTERLY',
	SEMI_ANNUALLY = 'SEMI_ANNUALLY',
	YEARLY = 'YEARLY'
}

export enum EmployerContributionTypeEnum {
	FIXED_AMOUNT = 'FIXED_AMOUNT',
	GROSS_SALARY_PERCENTAGE = 'GROSS_SALARY_PERCENTAGE'
}

export enum EmployeeContributionTypeEnum {
	FIXED = 'FIXED',
	PERCENTAGE = 'PERCENTAGE'
}

/**
 * Plan de empleo contratado por la empresa. Espejo de `CaserPlanSelectedType`
 * en comparsa (`src/companies/entities/company-epp-config.ts`), que es la fuente
 * de verdad de `company_epp_config.caser_plan_selected`.
 */
export enum CaserPlanSelected {
	EMPLOYMENT_100_ACTIONS = 'EMPLOYMENT_100_ACTIONS',
	EMPLOYMENT_LIFE_CYCLES = 'EMPLOYMENT_LIFE_CYCLES'
}

export enum HoldedInvoiceStatus {
	PENDING = 0,
	PAID = 1,
	CANCELLED = 3
}
